import { Action } from 'redux'

import { RecipeAvailability } from '@library/api-recipeavailability/src/types'

import { actionTypes } from 'actions/actionTypes'

export type RecipeAvailabilityStore = Record<string, RecipeAvailability>

export const initialState: RecipeAvailabilityStore = {}

export const recipeAvailabilityReducer = {
  recipeAvailability: (
    state: RecipeAvailabilityStore,
    action: Action<string> & { recipeAvailability: RecipeAvailabilityStore },
  ) => {
    if (!state) {
      return initialState
    }

    switch (action.type) {
      case actionTypes.RECIPE_AVAILABILITY_UPDATED: {
        return action.recipeAvailability
      }
      default: {
        return state
      }
    }
  },
}
